import { FC } from 'react';

import {
  DetailsPageDescription,
  DetailsPageHeader,
  FormattedLink,
  SpaTermsAndConditions,
  usePageContext,
} from '@common/components';
import Markdown from '@common/components/Markdown';
import SectionContainer from '@common/components/SectionContainer';
import Suggestions from '@common/components/Suggestions';
import { useTranslations } from '@lang';
import { ArrowLeftIcon } from '@root/styles/icons';
import {
  getDiscountForMinimumGuests,
  getPriceForMinimumGuests,
} from '@utils/getPriceForMinimumGuests';
import { EntityWrapper } from './SpaEntity.styles';
import { SpaEntityProps } from './SpaEntityContainer.types';

export const SpaEntityContainer: FC<SpaEntityProps> = ({
  spaEntity,
  spaTermsAndConditions,
  bookingStep,
  property,
  language,
  basketGuests,
  basketDetails,
  signIn,
  destroy,
  defaultTitle,
  SpaEntityConfigurationWizard,
  mergedItems,
  handleBasketUpdate,
}) => {
  const { t } = useTranslations();
  const { routingData } = usePageContext();
  return (
    <EntityWrapper>
      <SectionContainer>
        {routingData && (
          <FormattedLink format="link" href={routingData.href}>
            <ArrowLeftIcon width="35" height="35" />
            {routingData.message}
          </FormattedLink>
        )}
        <DetailsPageHeader
          name={spaEntity.name}
          image={spaEntity.image}
          imgixParams={{ crop: 'edges' }}
          metadata={{
            minGuests: spaEntity.minimumGuests,
            maxGuests: spaEntity.maximumGuests,
            duration: spaEntity.displayDuration || spaEntity.durationMinutes,
            price: getPriceForMinimumGuests(spaEntity.price, spaEntity.minimumGuests),
            discount: getDiscountForMinimumGuests(spaEntity.discount, spaEntity.minimumGuests),
          }}
        />
        <DetailsPageDescription title={t('spa.headingColumnTitle')}>
          <Markdown text={spaEntity.description} />
        </DetailsPageDescription>
      </SectionContainer>
      <Suggestions
        items={mergedItems}
        leadingCategoryId={
          spaEntity.crossSellTargetType === 'category' &&
          spaEntity.crossSellCategory &&
          spaEntity.crossSellCategory.id
        }
      />
      <SectionContainer>
        <SpaTermsAndConditions
          entityTermsAndConditions={spaEntity.termsAndConditions}
          spaTermsAndConditions={spaTermsAndConditions}
        />
        <SpaEntityConfigurationWizard
          spaEntity={spaEntity}
          bookingStep={bookingStep}
          language={language}
          arrivalTimesOptions={spaEntity.availability}
          handleBasketUpdate={handleBasketUpdate}
          destroyForm={destroy}
          existingGuests={basketGuests}
          basketDetails={basketDetails}
          suggestions={mergedItems}
          property={property}
          signIn={signIn}
          defaultTitle={defaultTitle}
        />
      </SectionContainer>
    </EntityWrapper>
  );
};
